import menu from 'assets/icons/menu.svg';
import { screenHeadersData } from 'data/ScreensData/screenData';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Menu } from 'primereact/menu';
import classes from './menuPopover.module.scss';
import { useMenuPopover } from './useMenuPopover';
import { useNavigate } from 'react-router-dom';
import { usePpsAccess } from 'hooks/usePpsAccess';

export default function MenuPopOver() {
  const { op, handleMenuClick, contextMenu, handleContextMenu, contextMenuItems } = useMenuPopover();
  const navigate = useNavigate();
  const {
    canViewReferenceTables,
    isLoading,
    canViewProductCalculations,
    canViewCleanCalculations,
    canViewScheduleCalculations
  } = usePpsAccess();

  // Filter menu items based on permissions
  const filteredMenuItems = !isLoading
    ? screenHeadersData.filter(item => {
      // Hide Reference Tables for users without permission
      if (item.route === '/reference') {
        return canViewReferenceTables();
      }
      if (item.route === '/calculations') {
        return (
          canViewProductCalculations() ||
          canViewCleanCalculations() ||
          canViewScheduleCalculations()
        );
      }
      return true;
    })
    : [];

  return (
    <div className={classes.menuButton}>
      <div onClick={handleMenuClick} className={classes.menuButtonIconWrapper}>
        <img className={classes.menuButtonIcon} src={menu} />
      </div>
      <OverlayPanel ref={op}>
        <div className={classes.menuPopover}>
          <table style={{ borderCollapse: 'collapse' }}>
            {!isLoading &&
              filteredMenuItems.map((menuItem, index) => {
                if (menuItem.route === '/' && location.pathname === '/') {
                  return (
                    <tr
                      className={classes.menuPopOverItem}
                      style={{ fontSize: '1rem', cursor: 'pointer' }}
                      key={menuItem.screenName + menuItem.route}
                      onClick={() => navigate(menuItem.route)}
                      onContextMenu={(e) => handleContextMenu(e, menuItem)}
                    >
                      <td className={classes.menuPopOvertd} style={{ padding: '0.5rem 0.8rem' }}>
                        <div className={classes.menuimg}>
                          <img src={menuItem.icon} />
                        </div>
                        <div className={classes.menuName}>{menuItem.screenName}</div>
                      </td>
                    </tr>
                  );
                }
                return (
                  <tr
                    className={classes.menuPopOverItem}
                    style={{ fontSize: '1rem', cursor: 'pointer' }}
                    key={menuItem.route + menuItem.screenName}
                    onClick={() => menuItem.route && navigate(menuItem.route)}
                    onContextMenu={(e) => handleContextMenu(e, menuItem)}
                  >
                    <td className={classes.menuPopOvertd} style={{ padding: '0.5rem 0.8rem' }}>
                      <div className={classes.menuimg}>
                        <img src={menuItem.icon} />
                      </div>
                      <div className={classes.menuName}>{menuItem.screenName}</div>
                    </td>
                  </tr>
                );
              })}
          </table>
        </div>
      </OverlayPanel>
      
      {/* Context Menu for right-click functionality */}
      <Menu
        model={contextMenuItems}
        popup
        ref={contextMenu}
        id="context_menu"
      />
    </div>
  );
}
